import AvatarGroup, {
  AvatarGroupSize,
  AvatarGroupStyle,
} from '../../../components/Avatar/AvatarGroup';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { getAllProfiles } from '../../../services/profiles';
import Avatar, { AvatarSize, AvatarStatus } from '../../../components/Avatar';

const Medical = () => {
  const profiles = getAllProfiles().data;

  const medicalInfo = [
    {
      profiles: profiles.slice(0, 1),
      doctors: [
        {
          name: 'Nicole Mattes',
          abbreviation: 'PCP',
          occupation: 'Primary Care Physician',
        },
        { name: 'Hong Xu', abbreviation: 'MD', occupation: 'Rheumatologist' },
      ],
    },

    {
      profiles: profiles.slice(1, 2),
      doctors: [
        {
          name: 'Grace Geno',
          abbreviation: 'PCP',
          occupation: 'Primary Care Physician',
        },
      ],
    },

    {
      profiles: profiles.slice(0, 2),
      doctors: [
        {
          name: 'Ivan Olesh',
          abbreviation: 'PCP',
          occupation: 'Primary Care Physician',
        },
      ],
    },
  ];

  return (
    <Row>
      {medicalInfo.map((info, idx) => {
        return (
          <>
            <Col key={idx} className={'col-12 mb-10'}>
              <Container className={'px-0 d-flex align-items-center'}>
                {info.profiles.length > 1 ? (
                  <AvatarGroup
                    groupSize={AvatarGroupSize.DEFAULT}
                    groupStyle={AvatarGroupStyle.STACKED}
                    avatars={info.profiles.map((x) => {
                      return {
                        id: x.id,
                        image: x.image,
                        status: AvatarStatus.ENABLED,
                        size: AvatarSize.EXTRA_SMALL,
                        name: x.name,
                        hasTooltip: false,
                      };
                    })}
                  />
                ) : (
                  <Avatar
                    id={info.profiles[0].id}
                    image={info.profiles[0].image}
                    status={AvatarStatus.ENABLED}
                    size={AvatarSize.SMALL}
                    name={info.profiles[0].name}
                  />
                )}
                <span className={'text-fs-base fw-normal ms-7'}>
                  {info.profiles
                    .map((profile) => {
                      return `${
                        profile.relationship === 'self'
                          ? 'You'
                          : `${profile.firstName}`
                      }`;
                    })
                    .join(', ')}
                </span>
              </Container>

              <Container className={'px-5'}>
                <Row className={'my-5'}>
                  {info.doctors.map((doctor, idx) => {
                    return (
                      <Col
                        key={idx}
                        className={`col-12 ${
                          idx % 2 === 0 ? 'striped-rows--odd' : ''
                        }`}
                      >
                        <Row className={'alignt-items-center'}>
                          <Col className={'col-6 d-flex flex-column px-4 py-5'}>
                            <span
                              className={'text-fs-6 fw-light lh-xxs'}
                            >{`${doctor.name}, ${doctor.abbreviation}`}</span>
                            <span
                              className={
                                'text-caption text-light-grey fw-light'
                              }
                            >
                              {doctor.occupation}
                            </span>
                          </Col>
                          <Col
                            className={
                              'col-6 d-flex align-items-center justify-content-end'
                            }
                          >
                            <FontAwesomeIcon
                              className={'me-3'}
                              icon={light('phone')}
                            />
                            <FontAwesomeIcon
                              className={'me-3'}
                              icon={light('location-dot')}
                            />
                            <FontAwesomeIcon icon={light('pen-to-square')} />
                          </Col>
                        </Row>
                      </Col>
                    );
                  })}
                </Row>
              </Container>
            </Col>
          </>
        );
      })}
    </Row>
  );
};

export default Medical;
